import { Utils } from '../util/utils'
import { Enums, ReferenceType } from '../common/enums'
import { Dictionary } from '../../helpers/dictionary'
import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'

// TODO !!!
// show() i hide() mają troche niespójne zachowanie z nazwą
// ponieważ tak naprawdę usuwają marker z mapy
// W przyszłości trzeba dodać remove() które faktycznie usunie z mapy
// a tamte ustawią visibility

export class OpMapArea {
    public get id() {
        return this.referenceValue
    }
    public set id(id: number) {
        this.referenceValue = id
    }
    public referenceValue: number
    public referenceType: ReferenceType
    public tooltip: string
    public lineColor: string
    public lineOpacity: number
    public lineWeight: number
    public fillColor: string
    public fillOpacity: number
    public type: Enums.SimaxMapAreaType
    public onClick: (mapElement: OpMapArea) => void
    public onDoubleClick: (mapElement: OpMapArea) => void

    // selection
    public selectedLineColor: string
    public selectedLineWeight: number
    public selectedFillOpacity: number

    constructor(opObject: any = null, type: Enums.SimaxMapAreaType = Enums.SimaxMapAreaType.Unknown) {
        this.type = type
        if (opObject) {

            if (opObject.Id !== undefined) {
                this.id = opObject.Id
            } else if (opObject.id !== undefined) {
                this.id = opObject.id
            }

            if (opObject.Tooltip !== undefined) {
                this.tooltip = opObject.Tooltip
            } else if (opObject.tooltip !== undefined) {
                this.tooltip = opObject.tooltip
            }

            if (opObject.LineColor) {
                this.lineColor = Utils.getHexColorFromSystemDrawingColor(opObject.LineColor)
            } else if (opObject.lineColor) {
                this.lineColor = Utils.getHexColorFromSystemDrawingColor(opObject.lineColor)
            }

            if (opObject.FillColor) {
                this.fillColor = Utils.getHexColorFromSystemDrawingColor(opObject.FillColor)
            } else if (opObject.fillColor) {
                this.fillColor = Utils.getHexColorFromSystemDrawingColor(opObject.fillColor)
            }

        }
    }
}

export class OpCoord {
    public latitude: number = 0
    public longitude: number = 0

    constructor(opObject: any = null) {
        if (opObject) {
            if (opObject.Latitude !== undefined) {
                this.latitude = opObject.Latitude
            } else if (opObject.latitude !== undefined) {
                this.latitude = opObject.latitude
            }

            if (opObject.Longitude !== undefined) {
                this.longitude = opObject.Longitude
            } else if (opObject.longitude !== undefined) {
                this.longitude = opObject.longitude
            }
        }
    }
}

export interface Polygon {
    isShown(): boolean
    show(): void
    hide(): void
    getMapPolygon(): any
}

export class OpPolygon extends OpMapArea {
    public coords: OpCoord[] = []

    private _polygon: Polygon = null
    // set polygon decorator
    public setPolygon(polygon: Polygon) {
        this._polygon = polygon
    }
    public getPolygon() {
        return this._polygon
    }

    constructor(opObject: any = null) {
        super(opObject, Enums.SimaxMapAreaType.Polygon)
        if (opObject) {
            if (opObject.Coords && opObject.Coords.length) {
                this.coords = opObject.Coords.map(c => new OpCoord(c))
            } else if (opObject.coords && opObject.coords.length) {
                this.coords = opObject.coords.map(c => new OpCoord(c))
            }
        }
    }

    public isSetOnMap(): boolean {
        return this._polygon != null
    }

    public isShown(): boolean {
        if (this.isSetOnMap())
            return this._polygon.isShown()
        throw Error('The polygon is not set')
    }
    public show() {
        if (this.isSetOnMap())
            return this._polygon.show()
        throw Error('The polygon is not set')
    }
    public hide() {
        if (this.isSetOnMap())
            return this._polygon.hide()
        throw Error('The polygon is not set')
    }
}

export interface Range {
    isShown(): boolean
    show(): void
    hide(): void
    getMapRange(): any
}

export class OpRange extends OpMapArea {
    public coords: OpCoord
    public radius: number

    private _range: Range = null
    // set range decorator
    public setRange(range: Range) {
        this._range = range
    }
    public getRange() {
        return this._range
    }

    constructor(opObject: any = null) {
        super(opObject, Enums.SimaxMapAreaType.Range)
        if (opObject) {
            if (opObject.Coords) {
                this.coords = new OpCoord(opObject.Coords)
            } else if (opObject.coords) {
                this.coords = new OpCoord(opObject.coords)
            }

            if (opObject.Radius !== undefined) {
                this.radius = opObject.Radius
            } else if (opObject.radius !== undefined) {
                this.radius = opObject.radius
            }
        }
    }

    public isSetOnMap(): boolean {
        return this._range != null
    }

    public isShown(): boolean {
        if (this.isSetOnMap())
            return this._range.isShown()
        throw Error('The range is not set')
    }
    public show() {
        if (this.isSetOnMap())
            return this._range.show()
        throw Error('The range is not set')
    }
    public hide() {
        if (this.isSetOnMap())
            return this._range.hide()
        throw Error('The range is not set')
    }
}

export interface Polyline {
    isShown(): boolean
    show(): void
    hide(): void
    getMapPolyline(): any
}

export class OpPolyline {
    public positions: OpCoord[]
    public lineColor: string
    public lineOpacity: number
    public lineWeight: number

    private _polyline: Polyline = null
    // set polyline decorator
    public setPolyline(polyline: Polyline) {
        this._polyline = polyline
    }
    public getPolyline() {
        return this._polyline
    }

    constructor(opObject: any = null) {
        if (opObject) {
            // TODO
            throw Error('OpPolyline is not defined in api')
        }
    }

    public isSetOnMap(): boolean {
        return this._polyline != null
    }

    public isShown(): boolean {
        if (this.isSetOnMap())
            return this._polyline.isShown()
        throw Error('The polyline is not set')
    }
    public show() {
        if (this.isSetOnMap())
            return this._polyline.show()
        throw Error('The polyline is not set')
    }
    public hide() {
        if (this.isSetOnMap())
            return this._polyline.hide()
        throw Error('The polyline is not set')
    }
}

export interface Marker {
    isShown(): boolean
    show(): void
    hide(): void
    setIcon(icon: string, scaledSize?: { width: number, height: number }): void
    setZIndex(index: number): void
    addListener(event: Enums.SimaxMarkerEvent, listener: (event) => void): void
    getPosition(): OpCoord
    getMapMarker(): any
    setPosition(position: OpCoord)
}

export class OpMarker extends OpMapArea {
    public coords: OpCoord
    public relatedMarkers: OpMarker[]
    public iconImage: string // base64
    public iconURL: string // url image from project
    public tooltip: string

    private _marker: Marker = null
    // set marker decorator
    public setMarker(marker: Marker) {
        this._marker = marker
    }
    public getMarker() {
        return this._marker
    }

    constructor(opObject: any = null) {
        super(opObject, Enums.SimaxMapAreaType.Marker)
    }

    public isSetOnMap(): boolean {
        return this._marker != null
    }

    public isShown(): boolean {
        if (this.isSetOnMap())
            return this._marker.isShown()
        throw Error('The marker is not set')
    }
    public show() {
        if (this.isSetOnMap())
            return this._marker.show()
        throw Error('The marker is not set')
    }
    public hide() {
        if (this.isSetOnMap())
            return this._marker.hide()
        throw Error('The marker is not set')
    }
    public setIcon(icon: string, scaledSize?: { width: number, height: number }) {
        if (this.isSetOnMap())
            return this._marker.setIcon(icon, scaledSize)
        throw Error('The marker is not set')
    }
    public setZIndex(index: number) {
        if (this.isSetOnMap())
            return this._marker.setZIndex(index)
        throw Error('The marker is not set')
    }
    public addListener(event: Enums.SimaxMarkerEvent, listener: (event) => void) {
        if (this.isSetOnMap())
            return this._marker.addListener(event, listener)
        throw Error('The marker is not set')
    }
    public getPosition(): OpCoord {
        if (this.isSetOnMap())
            return this._marker.getPosition()
        throw Error('The marker is not set')
    }
    // get instance of marker, not decorator
    public getMapMarker(): any {
        if (this.isSetOnMap())
            return this._marker.getMapMarker()
        throw Error('The marker is not set')
    }
    public setPosition(position: OpCoord) {
        if (this.isSetOnMap())
            return this._marker.setPosition(position)
        throw Error('The marker is not set')
    }
}

export class OpBounds {
    public southWest: OpCoord
    public northEast: OpCoord

    constructor(southWest: OpCoord = null, northEast: OpCoord = null) {
        this.southWest = southWest
        this.northEast = northEast
    }
}

export interface Tooltip {
    show(): void
    hide(): void
}

export class OpTooltip {
    private _tooltip: Tooltip = null
    // set tooltip decorator
    public setTooltip(tooltip: Tooltip) {
        this._tooltip = tooltip
    }

    constructor(opObject: any = null) {
        if (opObject) {
        }
    }

    public isSetOnMap(): boolean {
        return this._tooltip != null
    }

    public show() {
        if (this.isSetOnMap())
            return this._tooltip.show()
        throw Error('The tooltip is not set')
    }
    public hide() {
        if (this.isSetOnMap())
            return this._tooltip.hide()
        throw Error('The tooltip is not set')
    }
}

export class OpLegendItem {
    public description: OpDescr
    public color: number
    public iconIndex: number
    public icon: OpFile

    constructor(opObject: any = null) {
        if (opObject) {
            this.color = opObject.Color
            this.iconIndex = opObject.IconIndex
            if (opObject.Description)
                this.description = new OpDescr(opObject.Description)
            if (opObject.Icon)
                this.icon = new OpFile(opObject.Icon)
        }
    }
        
}